<script>
  // ?id=9921&dnApp=1&dnAppVersion=6.5.5&darkMode=1
  import { onMount, afterUpdate } from "svelte";
  import {
    baseUrl,
    getUrlVars,
    handleMargins,
    handleDarkModeSettings,
    useDarkMode,
    isForcedColorMode 
  } from "../../scripts/loadExternalData";

  export const state = {
    title: "",
    source: "",
    ingress:"",
    verticalTimeline: [],
    darkMode: "",
    colorSchema: "",
    selected: 0,
    hover: 0,
    timelineColor: "#222",
    titleColor: "#222",
    timelineColor: "#222",
    timelineTextSize: "16px",
    timelineLineHeight: "1.4",
    softStyle: 'Hard',
    departmentColor:'Default',
    expanderBox:false,
    leftInset:'',
    hideDot:"ingen",
    darkModeSettings:'Följ användarens tema'
  };

  export let graphicTitle = '';
  export let lineHeight = 0;

  $: myRenderDarkMode = getUrlVars().darkMode === '1';
  $: myRenderForcedColorMode = false;

  onMount(() => {
    window.addEventListener("resize", () => {
      postRatio();
      checkLineHeight();
    });

    setupLiveData();
    fetchGraphicData();
    postRatio();

    const checkFonts = setInterval(() => {
      if(!document.fonts.check) clearInterval(checkFonts);
      const loaded = document.fonts.check("16px DNSans");

      if(loaded) {
        checkLineHeight();
        clearInterval(checkFonts);
      }
    }, 250);
  });

  afterUpdate(() => {
    postRatio();
    checkLineHeight();


    setTimeout(() => {

      postRatio();
      checkLineHeight();

    }, 2000);

    setTimeout(() => {
      
      postRatio();
      checkLineHeight();

    }, 4000);
  })

  function postRatio() {
    const containerElement = document.getElementsByTagName("body")[0];

    window.parent.postMessage(
      {
        ratio: containerElement.offsetHeight / window.innerWidth,
        location: window.location.href,
      },
      "*"
    );
  }

  function postRatios() {

      setTimeout(function(){ postRatio(); }, 300);
      setTimeout(function(){ postRatio(); }, 500);
      setTimeout(function(){ postRatio(); }, 1000);
      setTimeout(function(){ postRatio(); }, 1500);
      setTimeout(function(){ postRatio(); }, 3000);

}


  function checkLineHeight() {
    const bulletPoints = Array.from(document.getElementsByClassName('bullet-point'));
    if(bulletPoints.length === 0) return;

    const startPoint = bulletPoints[0].getBoundingClientRect().top ;
    const endingPoint = bulletPoints[bulletPoints.length - 1].getBoundingClientRect().bottom;

    lineHeight = endingPoint - startPoint - 5; 
  }

  function setupLiveData() {
    window.addEventListener("message", (ev) => {
      if (!ev.data.key || ev.data.value === undefined) return;

      let { key, value } = ev.data;

      state[key] = value;

      if(state.darkMode || state.colorSchema === 'mörk') {
        state.colorSchema = 'dark';
      } else {
        state.colorSchema = 'light';
      }
    });
  }

  function fetchGraphicData() {
    fetch(`${baseUrl}/fields/${getUrlVars().id}`)
      .then((data) => data.json())
      .then(({ fields, title }) => {
        graphicTitle = title;
        
        for (let name in state) {
          if(!fields.find(({ key }) => key === name)) continue;

          state[name] = fields.find(({ key }) => key === name).value;
        }
        state.selected = parseInt(getUrlVars().artikel, 10);


        handleDarkModeSettings(false,state.darkMode,state.darkModeSettings);
      
        myRenderDarkMode = useDarkMode();
        myRenderForcedColorMode = isForcedColorMode();

        if ( myRenderDarkMode ) {
          document.getElementsByTagName("body")[0].classList.add("body__dark-mode");
          state.colorSchema = 'dark';
        } else {
          document.getElementsByTagName("body")[0].classList.add("body__light-mode");
          state.colorSchema = 'light';
        } 

  

        setTimeout(() => checkLineHeight(), 50);

      });
  }


function showTimeline(event) {

  //console.log('show');

       let h = document.querySelectorAll(".expanderbox UL")[0].offsetHeight;

       //console.log(h);

        document.getElementsByClassName("expanderboxbuttoshadow")[0].style.display = "none";
        document.getElementsByClassName("showbox")[0].style.display = "none";
        document.getElementsByClassName("hidebox")[0].style.display = "block";
        document.getElementsByClassName('expanderbox')[0].style.maxHeight = (h+50)+'px';

        postRatios();
      
}; 

  function hideTimeline (event) {
    //console.log('hide');
      document.getElementsByClassName("expanderboxbuttoshadow")[0].style.display = "block";
        document.getElementsByClassName("showbox")[0].style.display = "block";
        document.getElementsByClassName("hidebox")[0].style.display = "none";
        document.getElementsByClassName('expanderbox')[0].style.maxHeight = '400px';

        postRatios();
}; 




function getPadding(pstring) {

  if (typeof(pstring != 'undefined') && pstring != null) {

    pstring = pstring.trim();

    if(pstring.length > 4){

      const myArray = pstring.split(",");

      if(myArray.length == 4) {

        return ' ' + 'padding:' + myArray[0].trim() + ' ' + myArray[1].trim() + ' ' + myArray[2].trim() + ' ' + myArray[3].trim() + ';'
      }


    }


  } 

  return '';
 
}



</script>

<style global type="text/scss" lang="scss">




  main {
    max-width: 560px;
  }

  main.main__full-width {
    padding-left: 12px;
    padding-right: 16px;
  }

  .factbox-wrapper {
    position: relative;
    width: 100%;
  }

  ul {
    margin: 0;
    margin-block-start: 0px;
    margin-block-end: 0px;
    padding-inline: 0px;
    padding-inline-start: 0px;
    list-style-position: inside;
    list-style-type: none;
  }


  .factbox-title > span {color: #da000d;}
  .style-dark .factbox-title > span {color: #df7875;}

  .factbox-description {
    font-family: DNSans, Georgia, "Times New Roman", Times, serif;
    position: relative;
    overflow-wrap: break-word;
    color: #878787;
    margin-bottom: 3rem;
  }

  .factbox-description > div.listItem {
    position: relative;
    top: -0.7rem;
    font-size: 2.0135rem;
    text-decoration: none;
    color: #222;
    display: inline-block;
    vertical-align: top;
    line-height: 1.4;
    width: 90%;
    margin-top: 1px;
    box-sizing: border-box;
    padding-right: 1rem;

  }

  .factbox-description > div.listItem{
    color: #222;
  }

  @media screen and (min-width: 441px) {
    .factbox-description > div.listItem {
      font-size: 16px;
    }
  }

  .style-dark .factbox-description > div.listItem{
    color: #EDEDED;
  }






  .bullet-point-wrapper {

      
      display: inline-block;
      margin-right: 1.5rem;
      width: 10px;
      height: 10px;
      padding-top: 7px;
      padding-bottom: 7px;
      box-sizing: content-box;
      position: relative;
      top: -5px;
  }

  .bullet-point {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
  }

 


  .dot-connector {
    position: absolute;
    margin-left: 4px;
    margin-top: 0;
  }





  /* Default  Hard */

  .hard .bullet-point-wrapper { 

    background-color: transparent;
  }

  .hard .bullet-point {

    background-color: #878787;
  }

  .hard .dot-connector {
    border-left: 2px solid #878787;
    width: 2px;
  }



  /* Default  Hard  Dark m ode */

  .hard.style-dark .bullet-point {

    background-color: #767676;
    
  }

  .hard.style-dark .dot-connector {
    border-left: 2px solid #767676;
    width: 2px;
  }


  /* Soft */

  .soft .bullet-point-wrapper { 

    background-color: #fff;
  }


  .soft .bullet-point {

    background-color: #fa0715;
  }

  .soft .dot-connector {
    border-left: 1px solid #ddd;
    width: 1px;
  }

  /* Soft Dark mode */

  .soft.style-dark .bullet-point-wrapper { 

    background-color: rgb(31, 31, 31);;
  }
  .soft.style-dark .bullet-point {

    background-color: #fa0715;

  }


  .soft.style-dark .dot-connector {
    border-left: 1px solid #ddd;
    width: 1px;
  }







  /* Dot */

  .dot .bullet-point-wrapper { 

  background-color: #fff;
  }


.dot .bullet-point {

  background-color: #fa0715;
}

.dot .dot-connector {
  border-left: 1px solid transparent;
  width: 1px;
}

/* Soft Dark mode */

.dot.style-dark .bullet-point-wrapper { 

  background-color: rgb(31, 31, 31);;
}
.dot.style-dark .bullet-point {

  background-color: #fa0715;

}


.dot.style-dark .dot-connector {
border-left: 1px solid transparent;
width: 1px;
}







  /* COLORS */


  /* DEFAULT */

  .hard.default .bullet-point {background-color: #878787;}
  .hard.default .dot-connector {border-color: #878787;}

  .hard.default.style-dark .bullet-point {background-color: #878787;}
  .hard.default.style-dark .dot-connector {border-color: #878787;}

  .soft.default .bullet-point {background-color: #878787;}
  .soft.default.style-dark .bullet-point {background-color: #878787;}

  .dot.default .bullet-point {background-color: #878787;}
  .dot.default.style-dark .bullet-point {background-color: #878787;}

  .default .factbox-title > span {color: #da000d;}



  /* Nyheter */

  .hard.nyheter .bullet-point {background-color:  #da000d;}
  .hard.nyheter .dot-connector {border-color:  #da000d;}

  .hard.nyheter.style-dark .bullet-point {background-color:  #da000d;}
  .hard.nyheter.style-dark .dot-connector {border-color:  #da000d;}

  .soft.nyheter .bullet-point {background-color: #da000d;}
  .soft.nyheter.style-dark .bullet-point {background-color: #da000d;}

  .dot.nyheter .bullet-point {background-color: #da000d;}
  .dot.nyheter.style-dark .bullet-point {background-color: #da000d;}

  .nyheter .factbox-title > span {color: #da000d;}


  /* Sport */

  .hard.sport .bullet-point {background-color:  #f58e04;}
  .hard.sport .dot-connector {border-color:  #f58e04;}

  .hard.sport.style-dark .bullet-point {background-color:  #f58e04;}
  .hard.sport.style-dark .dot-connector {border-color:  #f58e04;}

  .soft.sport .bullet-point {background-color: #f58e04;}
  .soft.sport.style-dark .bullet-point {background-color: #f58e04;}

  .dot.sport .bullet-point {background-color: #f58e04;}
  .dot.sport.style-dark .bullet-point {background-color: #f58e04;}


  .sport .factbox-title > span {color: #f58e04;}


   /* Kultur */

  .hard.kultur .bullet-point {background-color:  #568bbe;}
  .hard.kultur .dot-connector {border-color:  #568bbe;}

  .hard.kultur.style-dark .bullet-point {background-color:  #568bbe;}
  .hard.kultur.style-dark .dot-connector {border-color:  #568bbe;}

  .soft.kultur .bullet-point {background-color: #568bbe;}
  .soft.kultur.style-dark .bullet-point {background-color: #568bbe;}

  .dot.kultur .bullet-point {background-color: #568bbe;}
  .dot.kultur.style-dark .bullet-point {background-color: #568bbe;}

  .kultur .factbox-title > span {color: #568bbe;}



  /* Ekonomi */

  .hard.ekonomi .bullet-point {background-color:  #60bca0;}
  .hard.ekonomi .dot-connector {border-color:  #60bca0;}

  .hard.ekonomi.style-dark .bullet-point {background-color:  #60bca0;}
  .hard.ekonomi.style-dark .dot-connector {border-color:  #60bca0;}

  .soft.ekonomi .bullet-point {background-color: #60bca0;}
  .soft.ekonomi.style-dark .bullet-point {background-color: #60bca0;}

  .dot.ekonomi .bullet-point {background-color: #60bca0;}
  .dot.ekonomi.style-dark .bullet-point {background-color: #60bca0;}

  .ekonomi .factbox-title > span {color: #60bca0;}


  /* Stockholm */

  .hard.stockholm .bullet-point {background-color:  #ff599c;}
  .hard.stockholm .dot-connector {border-color:  #ff599c;}

  .hard.stockholm.style-dark .bullet-point {background-color:  #ff599c;}
  .hard.stockholm.style-dark .dot-connector {border-color:  #ff599c;}

  .soft.stockholm .bullet-point {background-color: #ff599c;}
  .soft.stockholm.style-dark .bullet-point {background-color: #ff599c;}

  .dot.stockholm .bullet-point {background-color: #ff599c;}
  .dot.stockholm.style-dark .bullet-point {background-color: #ff599c;}

  .stockholm .factbox-title > span {color: #ff599c;}


    /* Osynlig */

  .hard.osynlig .bullet-point {background-color:  transparent}
  .hard.osynlig .dot-connector {border-color:  transparent;}

  .hard.osynlig.style-dark .bullet-point {background-color:  transparent;}
  .hard.osynlig.style-dark .dot-connector {border-color:  transparent;}

  .soft.osynlig .bullet-point {background-color: transparent;}
  .soft.osynlig.style-dark .bullet-point {background-color: transparent;}

  .dot.osynlig .bullet-point {background-color: transparent;}
  .dot.osynlig.style-dark .bullet-point {background-color: transparent;}





  .inlineImage {
    padding-top:0.7rem;
  }

  .source {

    color: #777;
    box-sizing: border-box;
    padding-bottom: 3rem;
    padding-left: 0px;
  }

  .main__full-width .source {
    padding-left: 4px;
  }




  .expanderbox {
    position: relative;
    width: 100%;
    height: auto;
    max-height: 400px;
    overflow: hidden;
    transition: all 1s ease;
}

.expanderboxbuttonwrapper { 
position:relative

}

.expanderboxbuttoshadow {
  position:relative

}


.expanderboxbuttoshadow::before { 
background: linear-gradient(180deg,hsla(0,0%,8%,0),#ffffff);
    content: "";
    height: 6rem;
    position: absolute;
    top: -6rem;
    width: 100%;
}
.main__dark-mode .expanderboxbuttoshadow::before {
  background: linear-gradient(180deg,hsla(0,0%,8%,0),#141414);
}
.expanderboxbutton {

    width: 135px;
    height: 40px;
    background-color: #e6e7e8;
    text-align: left;
    margin-bottom: 0.5rem;
    padding-top: 0.5rem;
    font-size: 16px;
    font-variation-settings: "opsz" 16;
    line-height: 1.5rem;
    font-weight: 600;
    color: #6b6b6b;
    fill: #6b6b6b;
    cursor: pointer;

    display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;

}

.main__dark-mode .expanderboxbutton {
background-color: #2c2c2c;
color: #ededed;
fill: #ededed;
}

.bboxwrapper {
  position: relative;
  background-color: transparant;
  padding-top: 1rem;
  top: -1rem;
  cursor: pointer;
}


.play {
  position: relative;
  z-index: 100;
  width: 2rem;
  height: 2rem;
  padding-left: 1rem;
}

.hidebox {display: none;}




@media screen and (min-width: 640px) {
  .main__full-width {
    margin: 0 auto;
  }
}

@media screen and (max-width: 400px) {

  .bullet-point-wrapper {
  width: 8px;
  height: 8px;
  padding-top: 5px;
  padding-bottom: 5px;
  top: -3px;
}

.bullet-point {
  width: 8px;
  height: 8px;
}

  .dot-connector {

    margin-left: 3px;
    margin-top: 3px;

  }

  main.main__full-width {
    padding-left: 13px;
    padding-right: 16px;
  }

  .main__full-width .source {
    padding-left: 3px;
  }

}



</style>


<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
 
  <symbol viewBox="0 0 24 24"  id="opensvg" >
      <polygon transform="translate(12.000000, 12.499990) rotate(-90.000000) translate(-12.000000, -12.499990) " points="16.4999898 2.49998976 6.49998976 12.5015898 16.4999898 22.4999898 17.5000102 21.4999898 8.49998976 12.5015898 17.5000102 3.49998976"></polygon>
  </symbol>
  
  <symbol viewBox="0 0 24 24"  id="closesvg" >
              <polygon  transform="translate(12.000000, 11.500000) rotate(-270.000000) translate(-12.000000, -11.500000) " points="6.5 11.5 16.5 21.5 17.5 20.5 8.5 11.5 17.5 2.5 16.5 1.5"></polygon>
  </symbol>
    
  <symbol viewBox="0 0 24 24" id="closeXsvg">
    <polygon points="20.0000 3.00000 12 11.00000 4.0001 3.00000 3.9999 3.00000 3 4.00000 11 12.00000 3 20.00000 4 21.00000 12 13.00000 20 21.00000 21 20.00000 13 12.00000 21 4.00000 20.0001 3.00000"></polygon>
  </symbol>

</svg>


<main
  class={`main__content-wrapper ${handleMargins() ? "main__padded-width" : "main__normal-width"} ${myRenderDarkMode ? "main__dark-mode" : "main__light-mode"} ${myRenderForcedColorMode ? "main__padded-top-bottom" : ""} ${state.softStyle ? state.softStyle.toLowerCase() : 'hard' } ${state.departmentColor ? state.departmentColor.toLowerCase() : 'default' } ${handleMargins() ? 'main__full-width' : ''}`}
> 
  
  <div class='factbox-wrapper'>
    <div class='factbox-title standard-title style-{state.colorSchema}'>
      {#if state.title.indexOf(':') !== -1}
        <span>{state.title.split(':')[0] }: </span>{state.title.split(':')[1]}
      {:else}
        {state.title}
      {/if}
    </div>
    {#if state.ingress !== ''}
    <div class="factbox-ingress standard-ingress">
      {@html state.ingress}
    </div>
    {/if}
    <div class={` ${state.expanderBox ? 'expanderbox' : '' } `}> 
    
      <div class='dot-connector' style='height: {lineHeight}px;' />
      <ul  class='style-{state.colorSchema}'>
        {#each state.verticalTimeline as timeItem, index}
          <li 
            class='factbox-description style-{state.colorSchema} 
            {index + 1 === state.selected && 'factbox-selected'}'
            style={!timeItem.text ? 'pointer-events: none' : ''}
          >
          {#if !(state.departmentColor == 'Osynlig' && state.softStyle == 'Dot') } 
              {#if (parseInt(state.hideDot) == index)}
              <div class='bullet-point-wrapper'><div class='bullet-point' style='background-color: transparent' /></div>
              {:else} 
              <div class='bullet-point-wrapper'><div class='bullet-point' /></div>
              {/if}     
          {/if}    

              <div class='factbox-description-link listItem' >
                {#if timeItem.image}
                  {#if timeItem.bildplacering == 'top'}
                  <img src={timeItem.image} class="inlineImage" style={`width:100%; display:block; padding: ${timeItem.bildpadding} 0;`}  alt="DN" />
                  <span style={state.leftInset ? 'display:block;padding-left:' +state.leftInset : ''}>{@html timeItem.text}</span> 
                  {:else if timeItem.bildplacering == 'bottom'}
                  <span style={state.leftInset ? 'display:block;padding-left:' +state.leftInset : ''}>{@html timeItem.text}</span> 
                  <img src={timeItem.image} class="inlineImage" style={`width:100%; display:block; padding: ${timeItem.bildpadding} 0;`}  alt="DN" />
                  {:else}
                  <img src={timeItem.image} class="inlineImage" style={`width: ${timeItem.bildstorlek ? timeItem.bildstorlek : '10%' }; float: ${timeItem.bildplacering ? timeItem.bildplacering : 'right'}; padding-${timeItem.bildplacering === 'left' ? 'right' : 'left'}: ${timeItem.bildpadding};`}  alt="DN" />
                  <span style={state.leftInset ? 'display:block;padding-left:' +state.leftInset : ''}>{@html timeItem.text}</span> 
                  {/if}
                {:else} 
                <span style={state.leftInset ? 'display:block;padding-left:' +state.leftInset : ''}>{@html timeItem.text}</span> 
                {/if}
                
              </div>
          </li>
        {/each}
      </ul>
    </div> 
    {#if state.expanderBox }  
    <div class='expanderboxbuttonwrapper'>
      <div class='expanderboxbuttoshadow'></div>
      <div class='showbox bboxwrapper'>
        <div  on:click={showTimeline} class='expanderboxbutton'> <span>Visa mer</span><svg class="play"><use xlink:href="#opensvg" /></svg></div>
      </div>
      <div  class='hidebox bboxwrapper'>
        <div  on:click={hideTimeline} class='expanderboxbutton'> <span>Visa mindre</span><svg class="play"><use xlink:href="#closesvg" /></svg></div>
      </div>
    </div>
    {/if}
  </div>
 





  <div id="source" class="standard-source">{@html state.source}</div>
</main>